export default "__VITE_ASSET__BhUuWcpu__"